import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import Spinner from '../Spinner';
import * as S from './styled';

const getContentElement = (modalProps, children) => (
  <S.Modal {...modalProps}>{children}</S.Modal>
);
const getOverlayElement = (modalProps, children) => (
  <S.Overlay {...modalProps}>{children}</S.Overlay>
);

const Modal = (props) => (
  <ReactModal
    contentElement={(modalProps, children) =>
      getContentElement({ ...modalProps, ...props }, children)
    }
    overlayElement={getOverlayElement}
    isOpen={props.isOpen}
    onRequestClose={props.handleClose}
    style={props.modalStyle}
  >
    <S.Header>
      <S.Button
        placement="left"
        onClick={props.handleClose}
      >
        Close
      </S.Button>
      {props.title && <S.Title>{props.title}</S.Title>}
      <S.Button
        placement="right"
        onClick={() => {
          if (!props.isSaving) {
            props.handleSubmit();
          }
        }}
        disabled={props.isSaving}
      >
        {!props.isSaving ? (
          `${props.handleSubmit ? props.doneLabel : ''}`
        ) : (
          <Spinner size={['22px', '22px']} />
        )}
      </S.Button>
    </S.Header>
    <S.Content>{props.children}</S.Content>
  </ReactModal>
);

Modal.defaultProps = {
  title: '',
  isSaving: false,
  modalStyle: {},
  doneLabel: 'Done',
  isMobile: false,
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  modalStyle: PropTypes.object,
  doneLabel: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default Modal;
